(function () {
  const hero = document.querySelector('[data-hl-hero]');
  if (hero) {
    const track = hero.querySelector('[data-hl-hero-track]');
    const slides = [...hero.querySelectorAll('[data-hl-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hl-hero-dot]')];
    const intervalMs = Number(hero.dataset.hlHeroInterval) || 5000;
    let index = 0;
    let autoplayTimer;

    const showSlide = (nextIndex) => {
      if (!slides.length || !track) return;
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const startAutoplay = () => {
      clearInterval(autoplayTimer);
      if (slides.length <= 1) return;
      autoplayTimer = setInterval(() => showSlide(index + 1), intervalMs);
    };

    const goToSlide = (nextIndex) => {
      showSlide(nextIndex);
      startAutoplay();
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goToSlide(Number(dot.dataset.hlHeroDot)));
    });

    startAutoplay();
  }

  document.querySelectorAll('[data-hl-video-grid]').forEach((grid) => {
    const players = [...grid.querySelectorAll('[data-hl-video-player]')]
      .map((player) => ({
        player,
        video: player.querySelector('.hl-video-card__video'),
        playButton: player.querySelector('[data-hl-video-play]'),
        linked: player.hasAttribute('data-hl-video-linked'),
      }))
      .filter((entry) => entry.video);

    if (!players.length) return;

    const intervalMs = Number(grid.dataset.hlVideoInterval) || 5000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let currentIndex = 0;
    let rotateTimer;
    let manualControl = false;

    const clearRotateTimer = () => {
      if (rotateTimer) {
        clearTimeout(rotateTimer);
        rotateTimer = undefined;
      }
    };

    const resetPlayer = ({ player, video }) => {
      video.pause();
      video.currentTime = 0;
      player.classList.remove('is-playing', 'is-active');
    };

    const pauseAll = () => {
      players.forEach(resetPlayer);
    };

    const primeThumbnails = () => {
      players.forEach(({ video }) => {
        if (video.readyState >= 1) return;
        video.load();
      });
    };

    const playAtIndex = async (index) => {
      if (manualControl || prefersReducedMotion) return;

      clearRotateTimer();
      pauseAll();

      const entry = players[index];
      if (!entry) return;

      const { player, video } = entry;
      video.currentTime = 0;

      try {
        await video.play();
        player.classList.add('is-playing', 'is-active');
      } catch (_error) {
        player.classList.remove('is-playing', 'is-active');
      }

      // Single video: let it loop in place. Multiple: rotate after interval.
      if (players.length <= 1) {
        video.loop = true;
        return;
      }

      rotateTimer = window.setTimeout(() => {
        resetPlayer(entry);
        currentIndex = (index + 1) % players.length;
        playAtIndex(currentIndex);
      }, intervalMs);
    };

    const startRotation = () => {
      if (manualControl || prefersReducedMotion || !players.length) return;
      playAtIndex(currentIndex);
    };

    const stopRotation = () => {
      manualControl = true;
      clearRotateTimer();
      pauseAll();
    };

    players.forEach((entry, index) => {
      const { player, video, playButton, linked } = entry;

      // Linked cards navigate to the product; keep autoplay only.
      if (linked) {
        video.addEventListener('ended', () => {
          if (manualControl) return;
          resetPlayer(entry);
          currentIndex = (index + 1) % players.length;
          playAtIndex(currentIndex);
        });
        return;
      }

      if (!playButton) return;

      const playManual = async () => {
        stopRotation();
        pauseAll();
        video.currentTime = 0;

        try {
          await video.play();
          player.classList.add('is-playing', 'is-active');
        } catch (_error) {
          player.classList.remove('is-playing', 'is-active');
        }
      };

      const pauseManual = () => {
        video.pause();
        player.classList.remove('is-playing');
        player.classList.toggle('is-active', !video.paused);
      };

      playButton.addEventListener('click', () => {
        if (video.paused) {
          playManual();
        } else {
          pauseManual();
        }
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          playManual();
        } else {
          pauseManual();
        }
      });

      video.addEventListener('pause', () => {
        player.classList.remove('is-playing');
        if (manualControl) {
          player.classList.remove('is-active');
        }
      });

      video.addEventListener('ended', () => {
        if (manualControl) return;
        resetPlayer(entry);
        currentIndex = (index + 1) % players.length;
        playAtIndex(currentIndex);
      });
    });

    primeThumbnails();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              startRotation();
            } else {
              clearRotateTimer();
              pauseAll();
            }
          });
        },
        { threshold: 0.35 }
      );
      observer.observe(grid);
    } else {
      startRotation();
    }
  });

  const drawer = document.querySelector('[data-hl-drawer]');
  const menuToggle = document.querySelector('[data-hl-menu-toggle]');
  const menuClose = document.querySelector('[data-hl-menu-close]');

  const openDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.hidden = false;
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.hidden = true;
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  menuToggle?.addEventListener('click', openDrawer);
  menuClose?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });

  const filterDrawer = document.querySelector('[data-hl-filter-drawer]');
  const filterOpen = document.querySelector('[data-hl-filter-open]');
  const filterCloseButtons = document.querySelectorAll('[data-hl-filter-close]');
  const mobileFilters = window.matchMedia('(max-width: 768px)');

  const openFilterDrawer = () => {
    if (!filterDrawer || !filterOpen || !mobileFilters.matches) return;
    filterDrawer.classList.add('is-open');
    filterOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeFilterDrawer = () => {
    if (!filterDrawer || !filterOpen) return;
    filterDrawer.classList.remove('is-open');
    filterOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  filterOpen?.addEventListener('click', openFilterDrawer);
  filterCloseButtons.forEach((button) => {
    button.addEventListener('click', closeFilterDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFilterDrawer();
  });

  mobileFilters.addEventListener('change', () => {
    if (!mobileFilters.matches) closeFilterDrawer();
  });

  const getActiveFabricFilters = () => {
    const params = new URLSearchParams(window.location.search);
    return params
      .getAll('filter.p.m.custom.fabric')
      .map((value) => value.trim())
      .filter(Boolean);
  };

  const applyFabricFilter = (grid) => {
    if (!grid) return;

    const activeFabrics = getActiveFabricFilters();
    grid.querySelectorAll('[data-hl-collection-item]').forEach((item) => {
      if (activeFabrics.length === 0) {
        item.hidden = false;
        return;
      }

      const fabric = item.dataset.fabric || '';
      item.hidden = !activeFabrics.includes(fabric);
    });
  };

  document.querySelectorAll('[data-hl-collection-filters]').forEach((form) => {
    const autoSubmit = () => {
      if (!mobileFilters.matches) form.submit();
    };

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', autoSubmit);
    });

    form.querySelectorAll('[data-hl-collection-sort]').forEach((select) => {
      select.addEventListener('change', autoSubmit);
    });
  });

  document.querySelectorAll('[data-hl-price-slider]').forEach((slider) => {
    const form = slider.closest('form');
    const minRange = slider.querySelector('[data-hl-price-min-range]');
    const maxRange = slider.querySelector('[data-hl-price-max-range]');
    const minInput = slider.querySelector('[data-hl-price-min-input]');
    const maxInput = slider.querySelector('[data-hl-price-max-input]');
    const minLabel = slider.querySelector('[data-hl-price-min-label]');
    const maxLabel = slider.querySelector('[data-hl-price-max-label]');
    const fill = slider.querySelector('[data-hl-price-fill]');

    if (!form || !minRange || !maxRange || !minInput || !maxInput || !minLabel || !maxLabel || !fill) {
      return;
    }

    const rangeMax = Number(maxRange.max) || 0;
    const currency = slider.dataset.currency || '₹';

    const formatMoney = (value) => `${currency}${Number(value).toLocaleString('en-IN')}`;

    const syncSlider = (submitForm) => {
      let min = Number(minRange.value);
      let max = Number(maxRange.value);

      if (min > max) {
        if (document.activeElement === minRange) {
          max = min;
          maxRange.value = String(min);
        } else {
          min = max;
          minRange.value = String(max);
        }
      }

      minInput.value = String(min);
      maxInput.value = String(max);
      minLabel.textContent = formatMoney(min);
      maxLabel.textContent = formatMoney(max);

      const percentMin = rangeMax > 0 ? (min / rangeMax) * 100 : 0;
      const percentMax = rangeMax > 0 ? (max / rangeMax) * 100 : 100;
      fill.style.left = `${percentMin}%`;
      fill.style.width = `${Math.max(percentMax - percentMin, 0)}%`;

      if (submitForm) form.submit();
    };

    minRange.addEventListener('input', () => syncSlider(false));
    maxRange.addEventListener('input', () => syncSlider(false));
    minRange.addEventListener('change', () => syncSlider(true));
    maxRange.addEventListener('change', () => syncSlider(true));

    syncSlider(false);
  });

  document.querySelectorAll('[data-hl-collection-infinite]').forEach((root) => {
    const sectionId = root.dataset.sectionId;
    const grid = root.querySelector('[data-hl-collection-grid]');
    const sentinel = root.querySelector('[data-hl-collection-sentinel]');
    const loading = root.querySelector('[data-hl-collection-loading]');
    const endMessage = root.querySelector('[data-hl-collection-end]');

    if (!sectionId || !grid) return;

    let currentPage = Number(grid.dataset.currentPage) || 1;
    let lastPage = Number(grid.dataset.lastPage) || 1;
    let loadingMore = false;
    const loadingText = loading?.textContent?.trim() || 'Loading more pieces…';

    const revealEnd = () => {
      if (endMessage) endMessage.hidden = false;
      if (sentinel) sentinel.remove();
      if (loading) loading.hidden = true;
    };

    if (currentPage >= lastPage) {
      revealEnd();
      return;
    }

    const loadNextPage = async () => {
      if (loadingMore || currentPage >= lastPage) return;

      loadingMore = true;
      if (loading) {
        loading.textContent = loadingText;
        loading.hidden = false;
      }

      const nextPage = currentPage + 1;
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(nextPage));
      url.searchParams.set('section_id', sectionId);

      try {
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(`Failed to load page ${nextPage}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sectionRoot =
          doc.getElementById(`shopify-section-${sectionId}`) ||
          doc.querySelector('[data-hl-collection-section]');
        const nextGrid = sectionRoot?.querySelector('[data-hl-collection-grid]');
        const items = nextGrid
          ? [...nextGrid.querySelectorAll('[data-hl-collection-item]')]
          : [...doc.querySelectorAll('[data-hl-collection-item]')];

        items.forEach((item) => grid.appendChild(item));
        applyFabricFilter(grid);
        if (typeof window.hlInitProductCardGalleries === 'function') {
          window.hlInitProductCardGalleries(grid);
        }

        currentPage = nextPage;
        if (nextGrid?.dataset.lastPage) {
          lastPage = Number(nextGrid.dataset.lastPage) || lastPage;
          grid.dataset.lastPage = String(lastPage);
        }
        grid.dataset.currentPage = String(currentPage);

        if (currentPage >= lastPage) revealEnd();
      } catch (_error) {
        if (loading) loading.textContent = 'Could not load more products. Scroll to try again.';
      } finally {
        loadingMore = false;
        if (loading && currentPage < lastPage) loading.hidden = true;
      }
    };

    if (sentinel && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
        },
        { rootMargin: '240px' }
      );
      observer.observe(sentinel);
    } else if (sentinel) {
      sentinel.addEventListener('click', loadNextPage);
    }

    applyFabricFilter(grid);
  });
})();

(function () {
  const INTERVAL_MS = 1400;
  const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const showImage = (images, index) => {
    images.forEach((img, i) => {
      const isActive = i === index;
      img.classList.toggle('is-active', isActive);
      if (isActive) {
        img.removeAttribute('aria-hidden');
      } else {
        img.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const bindGallery = (gallery) => {
    if (gallery.dataset.hlGalleryBound === 'true') return;
    gallery.dataset.hlGalleryBound = 'true';

    const images = [...gallery.querySelectorAll('[data-hl-card-gallery-image]')];
    if (images.length < 2) return;

    const media = gallery.closest('.hl-product-card__media') || gallery;
    let index = 0;
    let timer = null;

    const stop = () => {
      clearInterval(timer);
      timer = null;
      index = 0;
      showImage(images, 0);
    };

    const start = () => {
      if (!canHover() || timer) return;
      index = (index + 1) % images.length;
      showImage(images, index);
      timer = window.setInterval(() => {
        index = (index + 1) % images.length;
        showImage(images, index);
      }, INTERVAL_MS);
    };

    media.addEventListener('mouseenter', start);
    media.addEventListener('mouseleave', stop);
    media.addEventListener('focusin', start);
    media.addEventListener('focusout', (event) => {
      if (!media.contains(event.relatedTarget)) stop();
    });
  };

  window.hlInitProductCardGalleries = (root = document) => {
    root.querySelectorAll('[data-hl-card-gallery]').forEach(bindGallery);
  };

  window.hlInitProductCardGalleries();
})();

(function () {
  document.querySelectorAll('[data-hl-product-media]').forEach((root) => {
    const mainImage = root.querySelector('[data-hl-product-media-main]');
    const backdropImage = root.querySelector('[data-hl-product-media-backdrop]');
    const mainVideo = root.querySelector('[data-hl-product-media-video]');
    const videoToggle = root.querySelector('[data-hl-product-media-video-toggle]');
    const mainBox = root.querySelector('.hl-product-media__main');
    const thumbs = [...root.querySelectorAll('[data-hl-product-media-thumb]')];
    if (!mainImage || !thumbs.length) return;

    const thumbsList = root.querySelector('[data-hl-product-media-thumbs]');
    let activeIndex = Math.max(
      thumbs.findIndex((thumb) => thumb.classList.contains('is-active')),
      0
    );
    let fadeTimer = null;

    const syncVideoToggle = () => {
      if (!videoToggle || !mainVideo) return;
      const paused = mainVideo.paused;
      videoToggle.dataset.paused = String(paused);
      videoToggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    };

    const pauseMainVideo = () => {
      if (!mainVideo) return;
      mainVideo.pause();
      mainVideo.removeAttribute('src');
      mainVideo.load();
      mainVideo.hidden = true;
      if (videoToggle) videoToggle.hidden = true;
      mainBox?.classList.remove('is-showing-video');
    };

    const showMainVideo = (videoSrc, posterSrc) => {
      if (!mainVideo || !videoSrc) return;
      window.clearTimeout(fadeTimer);
      mainImage.classList.remove('is-fading');
      if (backdropImage) {
        backdropImage.classList.remove('is-fading');
        if (posterSrc) {
          backdropImage.src = posterSrc;
          backdropImage.removeAttribute('srcset');
        }
      }
      if (posterSrc) {
        mainImage.src = posterSrc;
        mainImage.removeAttribute('srcset');
      }
      if (mainVideo.getAttribute('src') !== videoSrc) {
        mainVideo.src = videoSrc;
      }
      mainVideo.hidden = false;
      if (videoToggle) videoToggle.hidden = false;
      mainBox?.classList.add('is-showing-video');
      const playPromise = mainVideo.play();
      if (playPromise?.catch) playPromise.catch(() => {});
      syncVideoToggle();
    };

    if (mainVideo) {
      // Right-click offers "Save video as…", so the shortcut is closed off too.
      mainVideo.addEventListener('contextmenu', (event) => event.preventDefault());
      mainVideo.addEventListener('play', syncVideoToggle);
      mainVideo.addEventListener('pause', syncVideoToggle);
    }

    videoToggle?.addEventListener('click', () => {
      if (!mainVideo) return;
      if (mainVideo.paused) {
        const playPromise = mainVideo.play();
        if (playPromise?.catch) playPromise.catch(() => {});
      } else {
        mainVideo.pause();
      }
      syncVideoToggle();
    });

    const activate = (index, { scrollThumb = true } = {}) => {
      const thumb = thumbs[index];
      if (!thumb) return;
      activeIndex = index;

      const nextSrc = thumb.dataset.src;
      const isVideo = thumb.dataset.mediaType === 'video' && Boolean(thumb.dataset.videoSrc);

      if (isVideo) {
        stopAutoplay();
        showMainVideo(thumb.dataset.videoSrc, nextSrc);
      } else {
        pauseMainVideo();
        if (nextSrc && mainImage.getAttribute('src') !== nextSrc) {
          mainImage.classList.add('is-fading');
          if (backdropImage) backdropImage.classList.add('is-fading');
          window.clearTimeout(fadeTimer);
          fadeTimer = window.setTimeout(() => {
            mainImage.src = nextSrc;
            mainImage.removeAttribute('srcset');
            mainImage.classList.remove('is-fading');
            if (backdropImage) {
              backdropImage.src = nextSrc;
              backdropImage.removeAttribute('srcset');
              backdropImage.classList.remove('is-fading');
            }
          }, 300);
        }
      }

      thumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');

      if (scrollThumb && thumbsList) {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    };

    // Auto-advance the main image through all views (skips while a video is playing).
    let autoplayTimer = null;
    const AUTOPLAY_MS = 5000;
    const startAutoplay = () => {
      if (thumbs.length < 2 || autoplayTimer) return;
      if (mainBox?.classList.contains('is-showing-video')) return;
      autoplayTimer = window.setInterval(() => {
        activate((activeIndex + 1) % thumbs.length, { scrollThumb: false });
      }, AUTOPLAY_MS);
    };
    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        activate(index, { scrollThumb: false });
        stopAutoplay();
        startAutoplay();
      });
    });

    if (mainBox) {
      mainBox.addEventListener('mouseenter', stopAutoplay);
      mainBox.addEventListener('mouseleave', startAutoplay);

      // Mobile-first: swipe the main image to change views.
      let swipeStartX = null;
      let swipeStartY = null;
      let swipeActive = false;
      const SWIPE_THRESHOLD_PX = 48;

      const onSwipeStart = (clientX, clientY) => {
        swipeStartX = clientX;
        swipeStartY = clientY;
        swipeActive = true;
        stopAutoplay();
      };

      const onSwipeEnd = (clientX, clientY) => {
        if (!swipeActive || swipeStartX == null || swipeStartY == null) {
          swipeActive = false;
          startAutoplay();
          return;
        }

        const deltaX = clientX - swipeStartX;
        const deltaY = clientY - swipeStartY;
        swipeActive = false;
        swipeStartX = null;
        swipeStartY = null;

        // Ignore mostly-vertical gestures so page scroll still works.
        if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX || Math.abs(deltaX) <= Math.abs(deltaY)) {
          startAutoplay();
          return;
        }

        if (deltaX < 0) {
          activate((activeIndex + 1) % thumbs.length);
        } else {
          activate((activeIndex - 1 + thumbs.length) % thumbs.length);
        }
        startAutoplay();
      };

      mainBox.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.changedTouches?.[0];
          if (!touch) return;
          onSwipeStart(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      mainBox.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches?.[0];
          if (!touch) return;
          onSwipeEnd(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      mainBox.addEventListener(
        'touchcancel',
        () => {
          swipeActive = false;
          swipeStartX = null;
          swipeStartY = null;
          startAutoplay();
        },
        { passive: true }
      );
    }

    if (typeof document.hidden === 'boolean') {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    }

    startAutoplay();

    const prevButton = root.querySelector('[data-hl-product-media-prev]');
    const nextButton = root.querySelector('[data-hl-product-media-next]');
    const thumbsWrap = thumbsList?.closest('.hl-product-media__thumbs-wrap');

    if (thumbsList && prevButton && nextButton && thumbsWrap) {
      const updateNavState = () => {
        const maxScroll = thumbsList.scrollWidth - thumbsList.clientWidth;
        const scrollable = maxScroll > 1;
        thumbsWrap.classList.toggle('is-scrollable', scrollable);
        prevButton.disabled = thumbsList.scrollLeft <= 1;
        nextButton.disabled = thumbsList.scrollLeft >= maxScroll - 1;
      };

      const scrollByStep = (direction) => {
        const step = Math.max(thumbsList.clientWidth * 0.7, 120);
        thumbsList.scrollBy({ left: step * direction, behavior: 'smooth' });
      };

      prevButton.addEventListener('click', () => scrollByStep(-1));
      nextButton.addEventListener('click', () => scrollByStep(1));
      thumbsList.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }
  });

  document.querySelectorAll('[data-hl-recommendations]').forEach((root) => {
    const scroller = root.querySelector('[data-hl-recommendations-scroll]');
    const prevButton = root.querySelector('[data-hl-recommendations-prev]');
    const nextButton = root.querySelector('[data-hl-recommendations-next]');
    if (!scroller || !prevButton || !nextButton) return;

    const updateNavState = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      root.classList.toggle('is-scrollable', maxScroll > 1);
      prevButton.disabled = scroller.scrollLeft <= 1;
      nextButton.disabled = scroller.scrollLeft >= maxScroll - 1;
    };

    const scrollByStep = (direction) => {
      const step = Math.max(scroller.clientWidth * 0.8, 240);
      scroller.scrollBy({ left: step * direction, behavior: 'smooth' });
    };

    prevButton.addEventListener('click', () => scrollByStep(-1));
    nextButton.addEventListener('click', () => scrollByStep(1));
    scroller.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();
  });

  document.querySelectorAll('[data-hl-recently-viewed]').forEach((root) => {
    const STORAGE_KEY = 'hl:recently-viewed:v2';
    const LEGACY_STORAGE_KEY = 'hl:recently-viewed';
    const MAX_STORED = 20;
    const LEGACY_HANDLE_ALIASES = {
      'saree-1': 'hl2680001',
      'saree-2': 'hl2680002',
      'saree-3': 'hl2680003',
      'saree-4': 'hl2680004',
      'saree-5': 'hl2680005',
      'saree-6': 'hl2680006',
      'saree-7': 'hl2680007',
      'kanjivaram-silk-saree-ruby-gold-border': 'hl2680001',
      'handwoven-silk-saree-temple-maroon': 'hl2680002',
      'kanchipuram-silk-saree-emerald-zari': 'hl2680003',
      'handwoven-silk-saree-royal-blue-motif': 'hl2680004',
      'kanjivaram-silk-saree-sunset-orange': 'hl2680005',
      'handwoven-silk-saree-ivory-classic': 'hl2680006',
      'kanchipuram-silk-saree-violet-heritage': 'hl2680007',
    };

    const grid = root.querySelector('[data-hl-recently-viewed-grid]');
    const scroller = root.querySelector('[data-hl-recently-viewed-scroll]');
    const prevButton = root.querySelector('[data-hl-recently-viewed-prev]');
    const nextButton = root.querySelector('[data-hl-recently-viewed-next]');
    const currentHandle = root.dataset.hlCurrentHandle || '';
    const currentId = root.dataset.hlCurrentId || '';
    const maxItems = parseInt(root.dataset.hlMax, 10) || 8;
    if (!grid) return;

    const resolveHandle = (handle) => {
      if (!handle) return '';
      const normalized = String(handle).trim().toLowerCase();
      return LEGACY_HANDLE_ALIASES[normalized] || normalized;
    };

    const normalizeEntry = (entry) => {
      if (typeof entry === 'string') {
        const handle = resolveHandle(entry);
        return handle ? { handle } : null;
      }
      if (entry && typeof entry === 'object') {
        const handle = resolveHandle(entry.handle);
        if (!handle) return null;
        return { handle, id: entry.id ? String(entry.id) : '' };
      }
      return null;
    };

    const readStoredEntries = () => {
      let raw = [];
      try {
        raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (_error) {
        raw = [];
      }

      if (!Array.isArray(raw) || raw.length === 0) {
        try {
          const legacy = JSON.parse(localStorage.getItem(LEGACY_STORAGE_KEY)) || [];
          if (Array.isArray(legacy) && legacy.length > 0) {
            raw = legacy;
          }
        } catch (_error) {
          raw = [];
        }
      }

      const seen = new Set();
      return raw
        .map(normalizeEntry)
        .filter((entry) => {
          if (!entry?.handle || seen.has(entry.handle)) return false;
          seen.add(entry.handle);
          return true;
        });
    };

    const writeStoredEntries = (entries) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, MAX_STORED)));
        localStorage.removeItem(LEGACY_STORAGE_KEY);
      } catch (_error) {
        /* ignore storage errors (private mode, quota) */
      }
    };

    let storedEntries = readStoredEntries();

    if (currentHandle) {
      const resolvedCurrentHandle = resolveHandle(currentHandle);
      const currentEntry = { handle: resolvedCurrentHandle, id: currentId };
      storedEntries = [
        currentEntry,
        ...storedEntries.filter((entry) => entry.handle !== resolvedCurrentHandle),
      ].slice(0, MAX_STORED);
      writeStoredEntries(storedEntries);
    }

    const toShow = storedEntries
      .filter((entry) => entry.handle && entry.handle !== resolveHandle(currentHandle))
      .slice(0, maxItems);

    if (toShow.length === 0) return;

    const updateNavState = () => {
      if (!scroller || !prevButton || !nextButton) return;
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      root.classList.toggle('is-scrollable', maxScroll > 1);
      prevButton.disabled = scroller.scrollLeft <= 1;
      nextButton.disabled = scroller.scrollLeft >= maxScroll - 1;
    };

    if (scroller && prevButton && nextButton) {
      const scrollByStep = (direction) => {
        const step = Math.max(scroller.clientWidth * 0.8, 240);
        scroller.scrollBy({ left: step * direction, behavior: 'smooth' });
      };
      prevButton.addEventListener('click', () => scrollByStep(-1));
      nextButton.addEventListener('click', () => scrollByStep(1));
      scroller.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
    }

    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    Promise.all(
      toShow.map((entry) =>
        fetch(`${rootPath}products/${encodeURIComponent(entry.handle)}?view=card`, {
          headers: { Accept: 'text/html' },
        })
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => ({ entry, html }))
          .catch(() => ({ entry, html: '' }))
      )
    ).then((results) => {
      const validHandles = new Set(
        storedEntries
          .filter((entry) => entry.handle !== resolveHandle(currentHandle))
          .map((entry) => entry.handle)
      );

      results.forEach(({ entry, html }) => {
        const markup = html && html.trim();
        if (!markup) {
          validHandles.delete(entry.handle);
          return;
        }
        const item = document.createElement('li');
        item.innerHTML = markup;
        grid.appendChild(item);
      });

      const cleanedEntries = storedEntries.filter((entry) => validHandles.has(entry.handle));
      if (cleanedEntries.length !== storedEntries.length) {
        writeStoredEntries(cleanedEntries);
      }

      if (grid.children.length > 0) {
        root.hidden = false;
        updateNavState();
      }
    });
  });

  document.querySelectorAll('[data-hl-product-form]').forEach((form) => {
    const section = form.closest('[data-hl-product-section]');
    const productJson = section?.querySelector('[data-hl-product-json]');
    const variantInput = form.querySelector('[data-hl-variant-id]');
    const message = form.querySelector('[data-hl-product-form-message]');
    const submitButton = form.querySelector('.hl-product-purchase__submit');
    const optionInputs = [...form.querySelectorAll('[data-hl-product-option]')];
    const purchaseRoot = form.closest('.hl-product-purchase');
    const priceEl = purchaseRoot?.querySelector('[data-hl-variant-price]');
    const compareEl = purchaseRoot?.querySelector('[data-hl-variant-compare]');
    const skuEl = purchaseRoot?.querySelector('[data-hl-variant-sku]');
    const stockEl = purchaseRoot?.querySelector('[data-hl-variant-stock]');
    const stockTextEl = purchaseRoot?.querySelector('[data-hl-variant-stock-text]');
    const inventoryJson = section?.querySelector('[data-hl-variant-inventory]');

    const formatVariantMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'INR';
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency,
          maximumFractionDigits: 0,
        }).format((cents || 0) / 100);
      } catch (_error) {
        return `₹${Math.round((cents || 0) / 100)}`;
      }
    };

    let inventoryData = {};
    if (inventoryJson) {
      try {
        inventoryData = JSON.parse(inventoryJson.textContent) || {};
      } catch (_error) {
        inventoryData = {};
      }
    }

    // Mirrors snippets/hangerloom-stock-status.liquid — keep the copy in sync.
    const describeStock = (quantity, threshold) => {
      if (quantity <= 0) return { state: 'out', label: 'Out of stock' };
      if (quantity === 1) return { state: 'last', label: 'Last piece left' };
      if (quantity <= threshold) return { state: 'low', label: `Only ${quantity} left` };
      return { state: 'in', label: `${quantity} in stock` };
    };

    const applyVariantStock = (variant) => {
      if (!stockEl || !stockTextEl) return;
      const entry = inventoryData[String(variant.id)];
      if (!entry || !entry.tracked) {
        stockEl.hidden = true;
        return;
      }
      const threshold = Number(stockEl.dataset.lowStockThreshold) || 2;
      const { state, label } = describeStock(entry.quantity, threshold);
      stockEl.dataset.stockState = state;
      stockTextEl.textContent = label;
      stockEl.hidden = false;
    };

    const applyVariantDisplay = (variant) => {
      if (!variant) return;
      applyVariantStock(variant);
      if (priceEl) priceEl.textContent = formatVariantMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatVariantMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
    };

    let productData = null;
    if (productJson) {
      try {
        productData = JSON.parse(productJson.textContent);
      } catch (_error) {
        productData = null;
      }
    }

    const findVariant = () => {
      if (!productData?.variants) return null;
      const selectedOptions = optionInputs
        .filter((input) => input.checked)
        .map((input) => input.value);
      return productData.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[index])
      );
    };

    const syncVariant = () => {
      const variant = findVariant();
      if (!variant || !variantInput) return;
      variantInput.value = String(variant.id);
      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available
          ? submitButton.dataset.availableLabel || submitButton.textContent
          : submitButton.dataset.soldOutLabel || 'Sold out';
      }
    };

    if (submitButton) {
      submitButton.dataset.availableLabel = submitButton.textContent.trim();
      submitButton.dataset.soldOutLabel = 'Sold out';
    }

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        syncVariant();
        applyVariantDisplay(findVariant());
      });
    });
    syncVariant();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (message) {
        message.hidden = true;
        message.classList.remove('is-success');
      }

      const formData = new FormData(form);
      try {
        const cart = await window.HLCart.addFormData(formData);
        window.HLCart.openDrawer(cart);
      } catch (error) {
        if (message) {
          message.hidden = false;
          message.textContent = error.message || 'Could not add to cart. Please try again.';
        }
      }
    });
  });

  document.querySelectorAll('[data-hl-product-card-add]').forEach((button) => {
    button.dataset.defaultLabel = button.getAttribute('aria-label') || 'Add to cart';
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-hl-product-card-add]');
    if (!button || button.disabled || button.classList.contains('is-adding')) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    let properties;
    if (button.dataset.properties) {
      try {
        properties = JSON.parse(button.dataset.properties);
      } catch (_error) {
        properties = undefined;
      }
    }

    button.classList.add('is-adding');

    try {
      const cart = await window.HLCart.addItem(Number(variantId), 1, properties);
      button.classList.remove('is-adding');
      button.classList.add('is-added');
      window.HLCart.openDrawer(cart);
      window.setTimeout(() => button.classList.remove('is-added'), 1800);
    } catch (error) {
      button.classList.remove('is-adding');
      button.setAttribute('aria-label', error.message || 'Could not add to cart');
      window.setTimeout(() => {
        button.setAttribute('aria-label', button.dataset.defaultLabel || 'Add to cart');
      }, 2500);
    }
  });
})();

/*
 * Shared cart controller (Ajax Cart API).
 * The cart itself is already persisted by Shopify via the browser's
 * `cart` cookie, so items stay in the bag whether the shopper is signed
 * in or not, and survive a sign-in on the same browser. This module just
 * keeps the header badge, mini-cart drawer, and cart page in sync with it.
 */
(function () {
  const cartRoot = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('[data-hl-cart-drawer]');
  const drawerItems = drawer?.querySelector('[data-hl-cart-drawer-items]');
  const drawerEmpty = drawer?.querySelector('[data-hl-cart-drawer-empty]');
  const drawerFooter = drawer?.querySelector('[data-hl-cart-drawer-footer]');
  const drawerCount = drawer?.querySelector('[data-hl-cart-drawer-count]');
  const drawerSubtotal = drawer?.querySelector('[data-hl-cart-drawer-subtotal]');
  const drawerMadeToOrder = drawer?.querySelector('[data-hl-cart-drawer-made-to-order]');

  const escapeHtml = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
      }).format((cents || 0) / 100);
    } catch (_error) {
      return `₹${Math.round((cents || 0) / 100)}`;
    }
  };

  const updateBadge = (count) => {
    document.querySelectorAll('[data-hl-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
    });
  };

  const renderLineProperties = (item) => {
    const properties = Object.entries(item.properties || {}).filter(
      ([name, value]) => name && !name.startsWith('_') && String(value ?? '').trim()
    );
    if (!properties.length) return '';

    return `
      <dl class="hl-cart-drawer__item-properties">
        ${properties
          .map(
            ([name, value]) =>
              `<div><dt>${escapeHtml(name)}:</dt><dd>${escapeHtml(value)}</dd></div>`
          )
          .join('')}
      </dl>
    `;
  };

  const renderDrawerItem = (item) => `
    <li class="hl-cart-drawer__item" data-line-key="${item.key}">
      <a class="hl-cart-drawer__item-media" href="${item.url}">
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
      </a>
      <div class="hl-cart-drawer__item-info">
        <a class="hl-cart-drawer__item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
        ${
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="hl-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>`
            : ''
        }
        ${item.sku ? `<p class="hl-cart-drawer__item-sku">SKU: ${escapeHtml(item.sku)}</p>` : ''}
        ${renderLineProperties(item)}
        <span class="hl-cart-drawer__item-price">${formatMoney(item.final_line_price)}</span>
        <div class="hl-cart-drawer__item-row">
          <div class="hl-cart-drawer__qty" data-line-key="${item.key}">
            <button type="button" data-hl-cart-qty-decrease aria-label="Decrease quantity">−</button>
            <span data-hl-cart-qty-value>${item.quantity}</span>
            <button type="button" data-hl-cart-qty-increase aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="hl-cart-drawer__item-remove" data-hl-cart-remove data-line-key="${item.key}">
            Remove
          </button>
        </div>
      </div>
    </li>
  `;

  const renderDrawer = (cart) => {
    if (!drawer) return;
    if (drawerCount) drawerCount.textContent = `(${cart.item_count})`;

    if (!cart.item_count) {
      if (drawerEmpty) drawerEmpty.hidden = false;
      if (drawerFooter) drawerFooter.hidden = true;
      if (drawerItems) drawerItems.innerHTML = '';
      return;
    }

    if (drawerEmpty) drawerEmpty.hidden = true;
    if (drawerFooter) drawerFooter.hidden = false;
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    if (drawerMadeToOrder) {
      drawerMadeToOrder.hidden = !cart.items.some((item) =>
        String(item.properties?.Dispatch || '').startsWith('Made to order')
      );
    }
    if (drawerItems) drawerItems.innerHTML = cart.items.map(renderDrawerItem).join('');
  };

  const openDrawer = (cart) => {
    if (!drawer) return;
    if (cart) renderDrawer(cart);
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hl-no-scroll');
    if (!cart) fetchCart().catch(() => {});
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hl-no-scroll');
  };

  async function fetchCart() {
    const response = await fetch(`${cartRoot}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Could not load cart');
    const cart = await response.json();
    renderDrawer(cart);
    updateBadge(cart.item_count);
    return cart;
  }

  async function addItem(variantId, quantity, properties) {
    const payload = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    const response = await fetch(`${cartRoot}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Could not add to cart');
    return fetchCart();
  }

  async function addFormData(formData) {
    const response = await fetch(`${cartRoot}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Could not add to cart');
    return fetchCart();
  }

  async function changeLine(key, quantity) {
    const response = await fetch(`${cartRoot}cart/change.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message || 'Could not update cart');
    renderDrawer(cart);
    updateBadge(cart.item_count);
    document.dispatchEvent(new CustomEvent('hl:cart:change', { detail: { cart } }));
    return cart;
  }

  window.HLCart = { fetchCart, addItem, addFormData, changeLine, openDrawer, closeDrawer, formatMoney };

  document.querySelectorAll('[data-hl-cart-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  drawer?.querySelectorAll('[data-hl-cart-drawer-close]').forEach((el) => {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  drawer?.addEventListener('click', async (event) => {
    const decreaseBtn = event.target.closest('[data-hl-cart-qty-decrease]');
    const increaseBtn = event.target.closest('[data-hl-cart-qty-increase]');
    const removeBtn = event.target.closest('[data-hl-cart-remove]');
    if (!decreaseBtn && !increaseBtn && !removeBtn) return;

    if (removeBtn) {
      const key = removeBtn.dataset.lineKey;
      if (key) changeLine(key, 0).catch(() => {});
      return;
    }

    const wrap = (decreaseBtn || increaseBtn).closest('[data-line-key]');
    const key = wrap?.dataset.lineKey;
    const qtyEl = wrap?.querySelector('[data-hl-cart-qty-value]');
    const current = Number(qtyEl?.textContent || 1);
    const next = increaseBtn ? current + 1 : Math.max(0, current - 1);
    if (key) changeLine(key, next).catch(() => {});
  });

  fetchCart().catch(() => {});
})();

/*
 * Custom cart page (/cart): quantity and remove controls update the cart
 * via the same Ajax Cart API, then re-fetch just the cart section markup
 * (Shopify's Section Rendering API) so the page stays in sync without a
 * full navigation.
 */
(function () {
  const cartPage = document.querySelector('[data-hl-cart-page]');
  if (!cartPage) return;

  const sectionId = cartPage.dataset.sectionId;
  const cartRoot = window.Shopify?.routes?.root || '/';

  const swapCartPage = async () => {
    if (!sectionId) return;
    try {
      const response = await fetch(`${cartRoot}cart?section_id=${sectionId}`);
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextPage = doc.querySelector('[data-hl-cart-page]');
      const currentPage = document.querySelector('[data-hl-cart-page]');
      if (nextPage && currentPage) {
        currentPage.replaceWith(nextPage);
      }
    } catch (_error) {
      /* noop: cart badge / drawer are already accurate */
    }
  };

  document.addEventListener('click', async (event) => {
    const decreaseBtn = event.target.closest('[data-hl-cart-page] [data-hl-cart-qty-decrease]');
    const increaseBtn = event.target.closest('[data-hl-cart-page] [data-hl-cart-qty-increase]');
    const removeBtn = event.target.closest('[data-hl-cart-page] [data-hl-cart-remove]');
    if (!decreaseBtn && !increaseBtn && !removeBtn) return;

    event.preventDefault();
    const trigger = decreaseBtn || increaseBtn || removeBtn;
    trigger.disabled = true;

    try {
      if (removeBtn) {
        await window.HLCart.changeLine(removeBtn.dataset.lineKey, 0);
      } else {
        const wrap = trigger.closest('[data-line-key]');
        const qtyEl = wrap?.querySelector('[data-hl-cart-qty-value]');
        const current = Number(qtyEl?.textContent || 1);
        const next = increaseBtn ? current + 1 : Math.max(0, current - 1);
        await window.HLCart.changeLine(wrap.dataset.lineKey, next);
      }
      await swapCartPage();
    } catch (_error) {
      trigger.disabled = false;
    }
  });
})();

(function () {
  const loader = document.querySelector('[data-hl-page-loader]');
  if (!loader) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let hideTimer;

  const showLoader = () => {
    clearTimeout(hideTimer);
    loader.hidden = false;
    loader.setAttribute('aria-hidden', 'false');
    // Force reflow so the fade-in runs after un-hiding.
    void loader.offsetWidth;
    loader.classList.add('is-visible');
  };

  const hideLoader = () => {
    loader.classList.remove('is-visible');
    loader.setAttribute('aria-hidden', 'true');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(
      () => {
        if (!loader.classList.contains('is-visible')) loader.hidden = true;
      },
      reduceMotion ? 0 : 240
    );
  };

  const isInternalNavLink = (anchor) => {
    if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return false;
    if (anchor.dataset.hlSkipLoader != null) return false;
    // Same-screen overlays / drawers — never treat as page navigation.
    if (anchor.closest('[data-hl-cart-open], [data-hl-cart-drawer], [data-hl-wishlist-open], [data-hl-wishlist-drawer], [data-hl-drawer], [data-hl-filter-drawer]')) {
      return false;
    }
    if (anchor.hasAttribute('data-hl-cart-open') || anchor.hasAttribute('data-hl-wishlist-open')) return false;

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
      return false;
    }

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (_error) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    // Same URL (including in-page hash jumps) — no loader.
    if (url.pathname === window.location.pathname && url.search === window.location.search) {
      return false;
    }

    return true;
  };

  // Bubble phase so drawer/modal handlers can preventDefault first.
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const anchor = event.target.closest?.('a[href]');
    if (!isInternalNavLink(anchor)) return;

    showLoader();
  });

  window.addEventListener('pageshow', hideLoader);
  document.addEventListener('DOMContentLoaded', hideLoader);
})();

/*
 * Wishlist controller.
 * Persists product handles in localStorage, scoped to the signed-in customer
 * when available so each account keeps its own list on this browser. Also
 * seeds from customer.metafields.custom.wishlist (Liquid bootstrap) and
 * mirrors changes back to that metafield via Admin when a sync endpoint is
 * configured — for now local + metafield bootstrap cover the theme path.
 */
(function () {
  const GUEST_KEY = 'hl:wishlist:v1';
  const boot = window.__HL__ || {};
  const customerId = boot.customerId ? String(boot.customerId) : '';
  const storageKey = customerId ? `${GUEST_KEY}:c${customerId}` : GUEST_KEY;
  const rootPath = window.Shopify?.routes?.root || '/';

  const drawer = document.querySelector('[data-hl-wishlist-drawer]');
  const drawerItems = drawer?.querySelector('[data-hl-wishlist-drawer-items]');
  const drawerEmpty = drawer?.querySelector('[data-hl-wishlist-drawer-empty]');
  const drawerCount = drawer?.querySelector('[data-hl-wishlist-drawer-count]');

  const normalizeEntry = (entry) => {
    if (typeof entry === 'string') {
      const handle = entry.trim().toLowerCase();
      return handle ? { handle } : null;
    }
    if (entry && typeof entry === 'object') {
      const handle = String(entry.handle || '').trim().toLowerCase();
      if (!handle) return null;
      return {
        handle,
        id: entry.id ? String(entry.id) : '',
      };
    }
    return null;
  };

  const uniqueByHandle = (entries) => {
    const seen = new Set();
    const out = [];
    entries.forEach((raw) => {
      const entry = normalizeEntry(raw);
      if (!entry || seen.has(entry.handle)) return;
      seen.add(entry.handle);
      out.push(entry);
    });
    return out;
  };

  const readStorage = (key) => {
    try {
      const raw = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(raw) ? uniqueByHandle(raw) : [];
    } catch (_error) {
      return [];
    }
  };

  const writeStorage = (key, entries) => {
    try {
      localStorage.setItem(key, JSON.stringify(uniqueByHandle(entries)));
    } catch (_error) {
      /* private mode / quota */
    }
  };

  const bootEntries = uniqueByHandle(Array.isArray(boot.wishlist) ? boot.wishlist : []);
  let entries = readStorage(storageKey);

  if (customerId) {
    const guestEntries = readStorage(GUEST_KEY);
    entries = uniqueByHandle([...entries, ...guestEntries, ...bootEntries]);
    writeStorage(storageKey, entries);
    if (guestEntries.length) writeStorage(GUEST_KEY, []);
  } else if (!entries.length && bootEntries.length) {
    entries = bootEntries;
    writeStorage(storageKey, entries);
  }

  const isSaved = (handle) => {
    const normalized = String(handle || '').trim().toLowerCase();
    return entries.some((entry) => entry.handle === normalized);
  };

  const syncButton = (button) => {
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const saved = isSaved(handle);
    button.classList.toggle('is-active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    const title = button.getAttribute('aria-label') || '';
    const base = title
      .replace(/^Remove\s+/i, '')
      .replace(/^Add\s+/i, '')
      .replace(/\s+to wishlist$/i, '')
      .replace(/\s+from wishlist$/i, '');
    button.setAttribute(
      'aria-label',
      saved ? `Remove ${base || 'product'} from wishlist` : `Add ${base || 'product'} to wishlist`
    );
  };

  const syncAllButtons = (root = document) => {
    root.querySelectorAll('[data-hl-wishlist-toggle]').forEach(syncButton);
  };

  const updateBadges = () => {
    const count = entries.length;
    document.querySelectorAll('[data-hl-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-hl-wishlist-open]').forEach((btn) => {
      btn.classList.toggle('has-items', count > 0);
    });
    if (drawerCount) drawerCount.textContent = `(${count})`;
  };

  const escapeHtml = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));

  let drawerRenderToken = 0;

  const renderDrawer = async () => {
    if (!drawer || !drawerItems || !drawerEmpty) return;
    const token = ++drawerRenderToken;
    updateBadges();

    if (!entries.length) {
      drawerItems.innerHTML = '';
      drawerItems.hidden = true;
      drawerEmpty.hidden = false;
      return;
    }

    drawerEmpty.hidden = true;
    drawerItems.hidden = false;
    drawerItems.innerHTML = '<li class="hl-wishlist-drawer__loading">Loading…</li>';

    const results = await Promise.all(
      entries.map((entry) =>
        fetch(`${rootPath}products/${encodeURIComponent(entry.handle)}.js`, {
          headers: { Accept: 'application/json' },
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => ({ entry, product }))
          .catch(() => ({ entry, product: null }))
      )
    );

    if (token !== drawerRenderToken) return;

    const valid = [];
    drawerItems.innerHTML = '';

    results.forEach(({ entry, product }) => {
      if (!product) return;
      valid.push(entry);
      const imageRaw =
        product.featured_image ||
        (Array.isArray(product.images) && product.images[0]) ||
        '';
      const image = String(imageRaw).startsWith('//') ? `https:${imageRaw}` : imageRaw;
      const price = product.price
        ? new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'INR',
            maximumFractionDigits: 0,
          }).format(product.price / 100)
        : '';

      const li = document.createElement('li');
      li.className = 'hl-wishlist-drawer__item';
      li.innerHTML = `
        <a class="hl-wishlist-drawer__item-media" href="${escapeHtml(product.url || `${rootPath}products/${entry.handle}`)}">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="" width="96" height="128" loading="lazy">`
              : '<span class="hl-wishlist-drawer__item-placeholder"></span>'
          }
        </a>
        <div class="hl-wishlist-drawer__item-info">
          <a class="hl-wishlist-drawer__item-title" href="${escapeHtml(product.url || `${rootPath}products/${entry.handle}`)}">${escapeHtml(product.title || entry.handle)}</a>
          ${price ? `<p class="hl-wishlist-drawer__item-price">${escapeHtml(price)}</p>` : ''}
        </div>
        <button
          type="button"
          class="hl-wishlist-drawer__item-remove is-active"
          data-hl-wishlist-toggle
          data-product-handle="${escapeHtml(entry.handle)}"
          data-product-id="${escapeHtml(entry.id || product.id || '')}"
          aria-label="Remove ${escapeHtml(product.title || 'product')} from wishlist"
          aria-pressed="true"
        ></button>
      `;

      const removeBtn = li.querySelector('[data-hl-wishlist-toggle]');
      if (removeBtn) {
        removeBtn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20.5 4.5 13a5.5 5.5 0 0 1 8-4.5 5.5 5.5 0 0 1 8 4.5Z"/></svg>';
      }
      drawerItems.appendChild(li);
    });

    if (valid.length !== entries.length) {
      entries = valid;
      writeStorage(storageKey, entries);
      syncAllButtons();
      updateBadges();
    }

    if (!valid.length) {
      drawerItems.hidden = true;
      drawerEmpty.hidden = false;
    }
  };

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hl-no-scroll');
    renderDrawer();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hl-no-scroll');
  };

  const persistCustomerMetafield = (() => {
    let timer;
    return () => {
      if (!customerId) return;
      window.__HL__.wishlist = entries;
      const syncUrl = boot.wishlistSyncUrl || window.__HL__.wishlistSyncUrl;
      if (!syncUrl) return;

      clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          await fetch(syncUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              customerId,
              wishlist: entries,
            }),
          });
        } catch (_error) {
          /* offline / proxy not installed */
        }
      }, 350);
    };
  })();

  const toggle = (handle, id = '') => {
    const normalized = String(handle || '').trim().toLowerCase();
    if (!normalized) return false;

    if (isSaved(normalized)) {
      entries = entries.filter((entry) => entry.handle !== normalized);
    } else {
      entries = [{ handle: normalized, id: id ? String(id) : '' }, ...entries];
    }

    writeStorage(storageKey, entries);
    syncAllButtons();
    updateBadges();
    persistCustomerMetafield();

    if (drawer && !drawer.hidden) renderDrawer();
    return isSaved(normalized);
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest?.('[data-hl-wishlist-open]');
    if (openBtn) {
      event.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = event.target.closest?.('[data-hl-wishlist-drawer-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const toggleBtn = event.target.closest?.('[data-hl-wishlist-toggle]');
    if (!toggleBtn || toggleBtn.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(toggleBtn.dataset.productHandle, toggleBtn.dataset.productId);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  // Infinite-scroll / recently-viewed cards injected later.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('[data-hl-wishlist-toggle]')) syncButton(node);
        else if (node.querySelectorAll) syncAllButtons(node);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  syncAllButtons();
  updateBadges();

  window.HLWishlist = {
    get entries() {
      return entries.slice();
    },
    isSaved,
    toggle,
    openDrawer,
    closeDrawer,
    refresh: () => {
      syncAllButtons();
      updateBadges();
    },
  };
})();
